module.exports = __webpack_public_path__ + "img/happycar.19ba414f.jpg";